import { useStrict, autorun, toJS } from "mobx"
import productStore from "./products/list/store"
import addProductStore from "./products/add/store"
import authStore from "./auth/auth-store"
import storefrontStore from "./storefront/store"
import createStore from "./create-store"

useStrict(true)
if (process.env.NODE_ENV === "development") {
  autorun(() => console.log("authStore", toJS(authStore)))
  autorun(() => console.log("createStore", toJS(createStore)))
  autorun(() => console.log("productStore", toJS(productStore)))
  autorun(() => console.log("storefrontStore", toJS(storefrontStore)))
  autorun(() => console.log("addProductStore", toJS(addProductStore)))
  window.authStore = authStore
  window.createStore = createStore
  window.productStore = productStore
  window.addProductStore = addProductStore
  window.storefrontStore = storefrontStore
}

export {
  authStore,
  storefrontStore,
  createStore,
  productStore,
  addProductStore,
}



// WEBPACK FOOTER //
// ./src/stores.js